const allColors = {
    mainColor: '#FFCC00',
    colors: [
        '#3166B1',
        '#EF3E33',
        '#152B62',
        '#57575A'
    ]
}

export default allColors